import { IResource } from '@gettactic/api';
import { Modal } from '@/components/basic';
import DeleteResource from '@/components/partial/Cards/Resources/DeleteResource';

export interface DeleteResourceModalProps {
  deleteModal: IResource[];
  setDeleteModal: React.Dispatch<React.SetStateAction<IResource[]>>;
  setSideDrawerOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DeleteResourceModal = ({
  deleteModal,
  setDeleteModal,
  setSideDrawerOpen
}: DeleteResourceModalProps) => {
  return (
    <Modal
      title="Confirm Action"
      opened={deleteModal.length > 0}
      onClose={() => setDeleteModal([])}
      size="max-w-[32rem]"
    >
      {deleteModal ? (
        <DeleteResource
          key={deleteModal.map((x) => x.id).join(',')}
          onClose={() => setDeleteModal([])}
          resources={deleteModal}
          setSideDrawerOpen={setSideDrawerOpen}
        />
      ) : null}
    </Modal>
  );
};
